import React from 'react';
import {Route, Navigate} from 'react-router-dom';
import home from './home/routes';
import diagnostics from './diagnostics/routes';
import hddiagnostics from './hddiagnostics/routes';
import emulation from './emulation/routes';

export default [
  <Route
    key="/business/showcase/skincare/"
    path="business/showcase/skincare/"
    element={<Navigate to="../business/showcase/skincare/home" replace />}
  />,
  home,
  diagnostics,
  hddiagnostics,
  emulation,
];

// skincarePaths lives in ./paths.js so utils don't have to import route files
